import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button, Input } from "../../components";
import { ChangeUserPassword } from "../../utilities";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { useAppDispatch } from "../../redux/Hooks/Hook";
import { DeleteProfile, SendOtpToUpdatePhoneEmail, VerifyOtpToUpdatePhoneEmail } from "../../utilities/api/auth/auth-service";
import { GetProfile, resetProfileDetailSlice } from "../../redux/Slice/Profile/ProfileDetailSlice";
import { NavLink } from "react-router-dom";
import { SendOtpBooking } from "../../utilities/api/courtBooking";
import { resetVerifyUserSlice } from "../../redux/Slice/Auth/VerifyUserSlice";
import { messages } from "../../utilities/Messages";
const getMessage = messages.profile;

const ChangeModal = ({ changePassword, setChangePassword, modalName, phoneNo }: any) => {
  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [otp, setOtp] = useState("")
  const [otpMessage, setOtpMessage] = useState("")
  const [otpSent, setOtpSent] = useState(false);
  // const otpInputRef = useRef<HTMLInputElement>(null);
  const [message, setMessage] = useState("")
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [currentStep, setCurrentStep] = useState(0)
  const [deleteBy, setDeleteBy] = useState("oldPassword")
  const _error = { phone: "", email: "" }
  const [error, setError] = useState(_error)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  let _logout = () => {
    dispatch(resetVerifyUserSlice());
    dispatch(resetProfileDetailSlice());
    localStorage.removeItem("device-uuid");
    localStorage.removeItem("authToken");
    localStorage.removeItem("device-token");
    navigate("/")
  }

  const ReGenerate = async () => {
    const result = await ChangeUserPassword({ oldPassword: oldPassword, newPassword: newPassword })
    if (result.status === 200) {
      setChangePassword(false)
      toast(result.data.message)
      setMessage("")
      _logout()
    } else {
      setMessage(result.response.data.message)
      toast.error(result.response.data.message)
    }
  }

  const ChangePhoneEmail = async () => {
    let payload = {
      otpFor: modalName === "Phone Number" ? "updatePhone" : "updateEmail",
      phone: modalName === "Phone Number" ? phone : "",
      email: modalName === "Email" ? email : "",
      otpNumber: otp
    }
    const result = await VerifyOtpToUpdatePhoneEmail(payload)
    if (result.status === 200) {
      if (modalName === "Phone Number") {
        _logout()
      } else {
        dispatch(GetProfile())
        setChangePassword(false)
      }
      setCurrentStep(0)
    } else {
      toast.error(result.response.data.message)
      setCurrentStep(0)
    }
  }

  const deleteUserProfile = async () => {
    let payload = {
      verifyBy: deleteBy === "oldPassword" ? "password" : "otpNumber",
      oldPassword: deleteBy === "oldPassword" ? oldPassword : "",
      otpNumber: deleteBy === "oldPassword" ? "" : otp
    }

    let _delete = await DeleteProfile(payload)
    if (_delete.status === 200) {
      _logout()
    } else {
      toast.error(_delete.response.data.message)
    }
  }

  const handleClick = () => {
    if (modalName === "Password") {
      if (/^\S+$/.test(newPassword)
        && newPassword && oldPassword && newPassword !== oldPassword) {
        ReGenerate()
      } else {
        if (!oldPassword) {
          toast.error(getMessage.password_oldNotEmpty)
        } else if (!newPassword) {
          toast.error(getMessage.password_newNotEmpty)
        } else if (newPassword === oldPassword) {
          toast.error(getMessage.password_same)
        } else {
          toast.error(getMessage.password_matches)
        }
      }
    } else if (modalName === "Delete") {
      deleteUserProfile()
    } else {
      ChangePhoneEmail()
    }
  }

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const validate = () => {
    if (modalName === "Phone Number") {
      if (phone.length !== 10) {
        setError({ ...error, phone: getMessage.phone_matches })
        return false
      }
    }
    else {
      if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
        setError({ ...error, email: getMessage.email_matches })
        return false
      }
    }
    return true
  }

  const handleResendOtp = async () => {
    setMinutes(1);
    if (validate()) {
      const result = await SendOtpToUpdatePhoneEmail({
        otpFor: modalName === "Phone Number" ? "updatePhone" : "updateEmail",
        phone: modalName === "Phone Number" ? phone : "",
        email: modalName === "Email" ? email : "",
      });
      if (result.status === 200) {
        setCurrentStep(1)
        setOtpMessage(result.data.data.otpNumber);
        setError(_error)
      } else {
        toast.error(result.response.data.message)
      }
    }
  };

  const handleSendDeleteOtp = () => {
    setDeleteBy("otp");
    setOtpSent(false);
    setOtpMessage("");
    setOtp("");
    setPhone("");
  };

  const handleSendDeleteOtpRequest = async () => {
    if (phone.length !== 10) {
      setMessage(getMessage.phone_matches);
      return;
    }
    const _deleteOtp = await SendOtpBooking({ phone, otpFor: "deleteAccount" });
    if (_deleteOtp.status === 200) {
      setOtpMessage(_deleteOtp.data.data.otpNumber);
      setMessage("");
      setOtpSent(true);
      // setTimeout(() => otpInputRef.current?.focus(), 0);
    } else {
      toast.error(_deleteOtp.response.data.message)
    }
  }

  return (
    <form>
      <Modal
        show={changePassword}
        onHide={() => {
          setChangePassword(false)
          setCurrentStep(0)
          setError(_error)
          setMessage("")
          setDeleteBy("oldPassword")
          setOtpSent(false)
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="regenerate-password"
      >
        <Modal.Header className="border-0 pb-0 pb-2" closeButton>
          <Modal.Title id="contained-modal-title-vcenter fw-semibold">
            {modalName !== "Delete" ? `Change ${modalName}` : "Delete Profile"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalName === "Delete" && (
            <>
              <p className="mb-0">Are you sure you want to Delete Your Profile?</p>
              {deleteBy === "oldPassword" ? (
                <>
                  <p>Please confirm your Old Password?</p>
                  <Input
                    onChange={(e: any) => setOldPassword(e.target.value)}
                    type="password"
                    placeholder="Enter Old Password"
                    id="oldpassword"
                    name="oldpassword"
                    className="form-control"
                    autoFocus
                    onKeyPress={(e: any) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleClick();
                      }
                    }}
                  />
                  <div className="align-items-center d-flex justify-content-between mt-1">
                    <div className="text-start">Forgot Password?</div>
                    <NavLink to="" onClick={() => handleSendDeleteOtp()}>
                      Delete Account With OTP.
                    </NavLink>
                  </div>
                </>
              ) : (
                <>
                  <label htmlFor="delete" className="form-label">
                    Enter Phone Number and OTP <small className="text-danger">*</small>
                  </label>
                  {otpSent && otpMessage}
                  <div className="row align-items-end">
                    <div className="col-md-8">
                      <div className="input-group">
                        <Input
                          type="number"
                          id="delete-phone"
                          name="delete-phone"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          value={phone}
                          onChange={(e: any) => setPhone(e.target.value)}
                          onKeyDown={(e: any) =>
                            ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                          }
                          onWheel={(e: any) => e.target.blur()}
                          autoFocus
                          onKeyPress={(e: any) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSendDeleteOtpRequest();
                            }
                          }}
                        />
                        <Button
                          onClick={handleSendDeleteOtpRequest}
                          type="button"
                          bname="Send OTP"
                          name="send-delete-otp"
                          id="send-delete-otp"
                          className="btn btn-primary btn-sm"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <Input
                        type="number"
                        id="delete-otp"
                        name="delete-otp"
                        className="form-control"
                        placeholder="Enter OTP"
                        max="4"
                        disabled={!otpSent}
                        autoFocus={otpSent}
                        onChange={(e: any) => setOtp(e.target.value)}
                        onKeyDown={(e: any) =>
                          ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                        }
                        onWheel={(e: any) => e.target.blur()}
                        onKeyPress={(e: any) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleClick();
                          }
                        }}
                      />
                    </div>
                  </div>
                  {message && <span className="error-msg text-danger">{message}</span>}
                  <div className="row align-items-center">
                    <div className="col-md-12 text-start mt-2">
                      <NavLink
                        to=""
                        onClick={() => {
                          setMessage("");
                          setDeleteBy("oldPassword");
                          setOtpSent(false);
                          setOtpMessage("");
                          setOtp("");
                          setPhone("");
                        }}
                      >
                        Delete Account With Old Password.
                      </NavLink>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {modalName === "Password" && (
            <>
              <div className="mb-3 text-start">
                <label htmlFor="password" className="form-label">
                  Old Password <small className="text-danger">*</small>
                </label>
                <Input
                  onChange={(e: any) => setOldPassword(e.target.value)}
                  type="password"
                  placeholder="Enter Old Password"
                  id="oldpassword"
                  name="oldpassword"
                  className="form-control"
                  autoFocus
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleClick();
                    }
                  }}
                />
              </div>
              <div className="mb-3 text-start">
                <label htmlFor="cpassword" className="form-label">
                  New Password <small className="text-danger">*</small>
                </label>
                <Input
                  onChange={(e: any) => setNewPassword(e.target.value)}
                  type="password"
                  placeholder="Enter New Password"
                  id="newpassword"
                  name="newpassword"
                  className="form-control"
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleClick();
                    }
                  }}
                />
              </div>
            </>
          )}
          {modalName === "Phone Number" && currentStep === 0 && (
            <div className="mb-3 text-start">
              <label htmlFor="phone-number" className="form-label">
                New Phone Number <small className="text-danger">*</small>
              </label>
              <Input
                onChange={(e: any) => setPhone(e.target.value)}
                type="Number"
                placeholder="Enter New Phone Number"
                id="phone-number"
                name="phone-number"
                className="form-control"
                onKeyDown={(e: any) => ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()}
                onWheel={(e: any) => e.target.blur()}
                autoFocus
                onKeyPress={(e: any) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleResendOtp()
                  }
                }}
              />
              <span className="error-msg">{error.phone}</span>
            </div>
          )}
          {modalName === "Email" && currentStep === 0 && (
            <div className="mb-3 text-start">
              <label htmlFor="email" className="form-label">
                New Email <small className="text-danger">*</small>
              </label>
              <Input
                onChange={(e: any) => setEmail(e.target.value)}
                type="test"
                placeholder="Enter Email"
                id="email"
                name="email"
                className="form-control"
                autoFocus
                onKeyPress={(e: any) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleResendOtp()
                  }
                }}
              />
              <span className="error-msg">{error.email}</span>
            </div>
          )}
          {(modalName === "Phone Number" || modalName === "Email") && currentStep === 1 && (
            <>
              <label htmlFor="email" className="form-label">
                OTP <small className="text-danger">*</small>
              </label>
              {otpMessage}
              <Input
                type="number"
                id="verify-otp"
                name="verify-otp"
                className="form-control"
                placeholder="Enter OTP"
                max="4"
                onChange={(e: any) => setOtp(e.target.value)}
                onKeyDown={(e: any) => ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()}
                onWheel={(e: any) => e.target.blur()}
                autoFocus
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleClick();
                  }
                }}
              />
            </>
          )}
          <div className="align-items-center d-flex justify-content-between mt-3">
            {(modalName === "Phone Number" || modalName === "Email") && currentStep === 1 && (
              <div className="align-items-center d-flex w-100 ">
                <Button
                  disabled={seconds > 0 || minutes > 0}
                  className="btn btn-link ps-0"
                  onClick={handleResendOtp}
                  bname="Resend OTP"
                  name="resend-otp"
                  id="resend-otp"
                />
                <div className="text-start">
                  {minutes === 0 && seconds === 0 ? null : (
                    <>
                      {" "}
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </>
                  )}
                </div>
              </div>
            )}
            <div className="text-end w-100">
              <Button
                onClick={() => {
                  if (["Phone Number", "Email"].includes(modalName) && currentStep === 0) {
                    handleResendOtp()
                  } else {
                    handleClick()
                  }
                }}
                type="button"
                bname={(["Phone Number", "Email"].includes(modalName) && currentStep === 0) ? "Send OTP" : modalName === "Delete" ? "Confirm" : "Submit"}
                name="submit"
                id="submit"
                className="btn btn-primary px-4 rounded-1 mt-1"
                disabled={
                  (["Phone Number", "Email"].includes(modalName) && currentStep === 1) ? otp.length !== 4
                  : (modalName === "Delete" && deleteBy === "otp") ? (!otpSent || otp.length !== 4)
                  : false
                }
              ></Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </form>
  )
}
export { ChangeModal }
